import React from 'react'

const Manage_store = () => {
  return (
    <div>Manage_store</div>
  )
}

export default Manage_store